<div class="p-dialog-header px-0">
  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs align-items-center">
      <span class="title-small-bold text-primary-color flex align-items-center gap-spacing-sm">
        Students<span class="body-medium-medium text-light-color">({{ config.data.studentNames.length }})</span>
      </span>
    </div>
  </div>
  <div class="p-dialog-header-icons">
    <app-button
      (click)="ref.close()"
      (keydown.enter)="ref.close()"
      [iconOnlyButton]="true"
      icon="icon-x"
      sizeClass="p-button-sm"
      severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>

<div class="flex flex-column gap-spacing-xs">
  <h5 class="body-small-medium text-light-color uppercase mb-0">Students Name</h5>
  @for (name of config.data.studentNames; track $index) {
    <span 
      class="background-muted-tertiary-bg label-large-medium text-primary-color border-round-md py-spacing-2xs px-spacing-xs">
      {{ name }}
    </span>
  }
</div>

<div class="p-dialog-footer pt-spacing-3xl px-0">
  <app-button
    label="Close"
    (click)="ref.close()"
    (keydown.enter)="ref.close()"
    sizeClass="p-button-md"
    severity="secondary"></app-button>
</div>
